// TeamOverviewComponent.jsx
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PlayerCardComponent from './PlayerCardComponent';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const TeamOverviewComponent = ({ team, onDelete }) => {
  const navigate = useNavigate();
  const { token, logout } = useContext(AuthContext);

  const handleEdit = () => {
    navigate(`/edit-team/${team.id}`);
  };

  const handleDelete = async () => {
    const confirmed = window.confirm(
      `Are you sure you want to delete "${team.team_name}"? This action cannot be undone.`
    );
    if (!confirmed) return;

    if (!token) {
      alert('No token. Please log in again.');
      logout?.();
      return;
    }

    try {
      const res = await fetch(`https://vballbackend.onrender.com/api/team/${team.id}/delete_team`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('DELETE /delete_team status:', res.status);

      if (res.status === 401) {
        alert('Session expired. Please log in again.');
        logout?.();
        return;
      }

      if (!res.ok) {
        const data = await res.json();
        alert(`Error: ${data.msg}`);
        return;
      }

      alert('Team deleted successfully');
      onDelete?.(); // ask parent to refresh
    } catch (err) {
      console.error('Delete team error:', err);
      alert('Failed to delete team.');
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div className="card" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="flex-row" style={{ alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <img
            src={team.photo_url || 'https://placehold.co/80x80?text=No+Image'}
            alt="Team Logo"
            className="img-logo"
            style={{
              width: '80px',
              height: '80px',
              objectFit: 'cover',
              borderRadius: '0.5rem',
              backgroundColor: '#f3f4f6'
            }}
          />
          <h2 className="ml-2">{team.team_name}</h2>
        </div>

        <div className="flex-row" style={{ gap: '0.5rem' }}>
          <button className="btn-secondary" onClick={handleEdit}>Edit</button>
          <button className="btn-danger" onClick={handleDelete}>Delete</button>
        </div>
      </div>

      <div className="flex-row" style={{ flexWrap: 'wrap', gap: '1rem', marginTop: '2rem' }}>
        {team.players.map((player) => (
          <PlayerCardComponent key={player.id} player={player} />
        ))}
      </div>
    </div>
  );
};

export default TeamOverviewComponent;
